import style from "./Input.module.css"

function Input(props){

    return (
        <div>
            <input
                className={props.errorClause? style.errorBorder:style.txtInput}
                type={props.type?props.type:"text"}
                placeholder={props.placeholder}
                id={props.id}
                value={props.value}
                onChange={props.onChange}
                disabled={props.disabled}
                style={props.style}
            />
            <div>
                {props.errorClause?<label className={style.errorMessage} htmlFor={props.id}>{props.errorMessage}</label>:null}
            </div>
        </div>

    )
}
export default Input